module.exports = __webpack_public_path__ + "fonts/free-fa-v4deprecations.3933457.eot";